import React, { useEffect, useRef } from 'react';
import { AbortSignals, useAbortSignals } from 'Hooks/useAbortSignals';

export type IsMountedCallback = (isMounted: () => boolean, abortSignals: AbortSignals) => void;

function useMounted() {
	const mounted = useRef(false);

	useEffect(() => {
		mounted.current = true;

		return () => {
			mounted.current = false;
		};
	}, []);

	return mounted;
}

function useOnMount(func: IsMountedCallback, deps: any[] = []) {
	const mounted = useMounted();
	const [
		createSignals, sendCancelSignals,
	] = useAbortSignals();

	useEffect(() => {
		const abortSignals = createSignals();
		func(() => mounted.current, abortSignals);
		return () => {
			sendCancelSignals();
		};
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [createSignals, mounted, ...deps]);

	useEffect(() => {
		return () => {
			sendCancelSignals();
		};
	}, [sendCancelSignals]);
}

export {
	useMounted,
	useOnMount,
};
